import { render } from "./ComponentProvider.vue?vue&type=template&id=170494c0"
import script from "./ComponentProvider.vue?vue&type=script&lang=js"
export * from "./ComponentProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__